"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_TYPE = exports.PARTNER_TARGET = void 0;
var PARTNER_TARGET;
(function (PARTNER_TARGET) {
    PARTNER_TARGET["Processor"] = "processor";
    PARTNER_TARGET["Dawn"] = "dawn";
    PARTNER_TARGET["Indi"] = "indi";
    PARTNER_TARGET["Widget"] = "widget";
    PARTNER_TARGET["IndiProduct"] = "indi_product";
    PARTNER_TARGET["ChronosPlus"] = "chronos_plus";
    PARTNER_TARGET["WidgetOther"] = "third_party_widget";
    PARTNER_TARGET["WidgetNatalMap"] = "widget_natal_map";
})(PARTNER_TARGET = exports.PARTNER_TARGET || (exports.PARTNER_TARGET = {}));
var PAYMENT_TYPE;
(function (PAYMENT_TYPE) {
    PAYMENT_TYPE["WIDGET"] = "widget";
    PAYMENT_TYPE["ADDITIONAL"] = "additional";
    PAYMENT_TYPE["SUBSCRIBE"] = "subscribe";
    PAYMENT_TYPE["INDI_SUBSCRIBE"] = "indiSubscribe";
    PAYMENT_TYPE["INDI_TRIAL"] = "indiTrial";
    PAYMENT_TYPE["INDI_PROLONG"] = "indiProlong";
    PAYMENT_TYPE["RECURRENT"] = "recurrent";
    PAYMENT_TYPE["FORMATION"] = "formation";
    PAYMENT_TYPE["CONSULTATION"] = "consultation";
    PAYMENT_TYPE["COURSE"] = "course";
    PAYMENT_TYPE["INDI"] = "indi";
    PAYMENT_TYPE["PAYOUT"] = "payout";
    PAYMENT_TYPE["TILDA"] = "tilda";
})(PAYMENT_TYPE = exports.PAYMENT_TYPE || (exports.PAYMENT_TYPE = {}));
